import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import Loader from "../components/Loader";
import ViewModal from "../components/ViewModal";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function Processes() {
  const { country } = useParams();
  const isAdmin = Cookies.get("user_role") === "Administrator";
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [query, setQuery] = useState("");
  const [viewOpen, setViewOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/getprocesses/${encodeURIComponent(country)}`, {
        headers: { Authorization: apiKey, "Content-Type": "application/json" },
      })
      .then((res) => {
        setItems(res.data || []);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [country]);

  const handleCopy = async (item) => {
    const stripHtml = (html) => {
      const div = document.createElement("div");
      div.innerHTML = html || "";
      return div.textContent || div.innerText || "";
    };
    try {
      await navigator.clipboard.writeText(`${item.Title}\n\n${stripHtml(item.ProcessCode)}`);
      alert("Copied.");
    } catch (error) {
      console.log(error);
    }
  };

  const filtered = items.filter((item) => {
    const q = query.toLowerCase();
    return (
      item.Title.toLowerCase().includes(q) ||
      item.ProcessCode.toLowerCase().includes(q)
    );
  });

  if (loading) return <Loader />;

  return (
    <div className="container">
      <h2>{country} - Process</h2>
      <br />
      <div className="row">
        {isAdmin && (
          <div className="col-sm-3">
            <Link to={`/countries/${country}/process/addprocess`}>
              <button className="btn btn-primary">Add New Process</button>
            </Link>
          </div>
        )}
        <div className="col-sm-4">
          <input
            type="text"
            className="form-control"
            placeholder="Search process..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </div>
      <br />
      <table className="table table-striped table-dark crm-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Process</th>
            <th className="crm-col-actions">View</th>
            <th>Created At</th>
            <th className="crm-col-actions">Copy</th>
            {isAdmin && (
              <>
                <th className="crm-col-actions">Update</th>
                <th className="crm-col-actions">Delete</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {filtered.map((item) => (
            <tr key={item.Id}>
              <td>{item.Title}</td>
              <td
                className="crm-cell-box"
                style={{ userSelect: "text" }}
              >
                <div
                  className="crm-preview"
                  dangerouslySetInnerHTML={{ __html: item.ProcessCode }}
                ></div>
              </td>
              <td className="crm-col-actions">
                <button
                  className="btn btn-sm btn-light crm-icon-btn"
                  onClick={() => {
                    setSelected(item);
                    setViewOpen(true);
                  }}
                  title="View"
                >
                  <i className="bi bi-eye"></i>
                </button>
              </td>
              <td>{item.Created_At}</td>
              <td className="crm-col-actions">
                <button
                  className="btn btn-sm btn-info crm-icon-btn"
                  onClick={() => handleCopy(item)}
                  title="Copy"
                >
                  <i className="bi bi-clipboard"></i>
                </button>
              </td>
              {isAdmin && (
                <>
                  <td className="crm-col-actions">
                    <Link to={`/countries/${country}/process/updateprocess/${item.Id}`}>
                      <span className="btn btn-sm btn-light crm-icon-btn" title="Update">
                        <i className="bi bi-pencil-square text-dark"></i>
                      </span>
                    </Link>
                  </td>
                  <td className="crm-col-actions">
                    <Link to={`/countries/${country}/process/deleteprocess/${item.Id}`}>
                      <span className="btn btn-sm btn-light crm-icon-btn" title="Delete">
                        <i className="bi bi-trash3 text-danger"></i>
                      </span>
                    </Link>
                  </td>
                </>
              )}
            </tr>
          ))}
          {filtered.length === 0 && (
            <tr>
              <td colSpan={isAdmin ? 7 : 5} className="text-center">
                No process found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <ViewModal
        open={viewOpen}
        title={selected ? `Process - ${selected.Title}` : "Process"}
        onClose={() => setViewOpen(false)}
      >
        {selected && (
          <>
            <div className="mb-2 text-muted">
              <div>
                <strong>Country:</strong> {country}
              </div>
              <div>
                <strong>Created At:</strong> {selected.Created_At}
              </div>
            </div>
            <div
              className="p-3"
              style={{ border: "1px solid #e5e5e5", borderRadius: "10px" }}
              dangerouslySetInnerHTML={{ __html: selected.ProcessCode }}
            ></div>
          </>
        )}
      </ViewModal>
    </div>
  );
}
